import { useJobPdfQuery } from '@lib/api/jobs';
import {
  Document,
  Image,
  Page,
  PDFViewer,
  Text,
  View,
} from '@react-pdf/renderer';
import i18n from '@translations/i18n';

import { pdfPageStyles } from './pdfPageStyles';
import type { JobPdfDetails } from './pdfPageTypes';

// react-pdf renders outside React context, so use the i18n instance directly
const t = (key: string): string => String(i18n.t(key));

const PdfPage = (): JSX.Element => {
  const { data } = useJobPdfQuery(422);
  const pdfData = (data ?? {}) as JobPdfDetails;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <PDFViewer style={pdfPageStyles.viewer}>
        <Document>
          <Page size="A4" style={pdfPageStyles.page}>
            <View style={pdfPageStyles.sections}>
              <Text>{t('report.pageTitle')}</Text>
            </View>
            <View style={pdfPageStyles.sectionHeading}>
              <Text>{t('report.vehicleInfo')}</Text>
            </View>
            <View style={pdfPageStyles.sectionContainer}>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.year')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.year}</Text>
              </View>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.make')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.make}</Text>
              </View>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.model')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.model}</Text>
              </View>
            </View>
            <View style={pdfPageStyles.sectionHeading}>
              <Text>{t('report.location')}</Text>
            </View>
            <View style={pdfPageStyles.sectionContainer}>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.location')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.contactName}</Text>
              </View>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.address')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.address}</Text>
              </View>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.zipCode')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.zip}</Text>
              </View>
            </View>
            <View style={pdfPageStyles.sectionContainer}>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.contactNumber')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.contactNumber}</Text>
              </View>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.city')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.city}</Text>
              </View>
              <View style={pdfPageStyles.sectionTable}>
                <Text>{t('report.state')}</Text>
                <Text style={pdfPageStyles.text}>{pdfData?.state}</Text>
              </View>
            </View>
          </Page>
          {pdfData?.ratingCriteriaUsers?.map((item) => (
            <Page key={item.id}>
              <View style={pdfPageStyles.sectionHeading}>
                <Text>{item?.ratingCriteria?.title}</Text>
              </View>
              <View style={pdfPageStyles.sectionContainer}>
                <View style={pdfPageStyles.sectionTableRating}>
                  <Text>{t('report.damages')}</Text>
                  <Text style={pdfPageStyles.text}>
                    {item?.ratingCriteriaOption?.ratingTitle}
                  </Text>
                </View>
              </View>
              <div style={pdfPageStyles.sectionContainerVideo}>
                {item?.ratingCriteriaUserMedia?.map((video) => (
                  <div
                    key={video.id}
                    style={pdfPageStyles.sectionContainerCol}
                  >
                    <Image src={video.url ?? ''} style={pdfPageStyles.images} />
                  </div>
                ))}
              </div>
            </Page>
          ))}
          <Page>
            <View style={pdfPageStyles.sectionHeading}>
              <Text>{t('report.specialMessage')}</Text>
            </View>
            <View style={pdfPageStyles.sectionContainer}>
              <View style={pdfPageStyles.sectionMessage}>
                <Text>{pdfData?.specialMessage?.specialMessage}</Text>
              </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default PdfPage;
